import React from "react";
import "./pagination.css";

const Pagination = ({ page, totalPages, setPage, style }) => {
  if (totalPages <= 1) return null;

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    if (start > 1) {
      pages.push(
        <button
          key={1}
          className={`page-btn ${page === 1 ? "active" : ""}`}
          onClick={() => setPage(1)}
        >
          1
        </button>
      );

      if (start > 2) {
        pages.push(
          <span key="ellipsis-start" className="ellipsis">
            ...
          </span>
        );
      }
    }

    for (let i = start; i <= end; i++) {
      pages.push(
        <button
          key={i}
          className={`page-btn ${page === i ? "active" : ""}`}
          onClick={() => setPage(i)}
        >
          {i}
        </button>
      );
    }

    if (end < totalPages) {
      if (end < totalPages - 1) {
        pages.push(
          <span key="ellipsis-end" className="ellipsis">
            ...
          </span>
        );
      }

      pages.push(
        <button
          key={totalPages}
          className={`page-btn ${page === totalPages ? "active" : ""}`}
          onClick={() => setPage(totalPages)}
        >
          {totalPages}
        </button>
      );
    }

    return pages;
  };

  return (
    <div className="pagination-container" style={style}>
      <button
        className="pagination-nav-btn"
        onClick={() => setPage((p) => Math.max(1, p - 1))}
        disabled={page === 1}
      >
        <span className="pagination-arrow">‹</span>
        Prev
      </button>

      <div className="page-numbers">
        {renderPageNumbers()}
      </div>

      <button
        className="pagination-nav-btn"
        onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
        disabled={page === totalPages}
      >
        Next
        <span className="pagination-arrow">›</span>
      </button>
    </div>
  );
};

export default Pagination;